import React, { useState } from "react";
import ErrMapper from '../../common/ErrMapper'
import ApiService from "../../../services/api.service";
import { useDispatch } from 'react-redux';
import IdleTimer from "../../../services/utils/Timer";
import { useNavigate } from "react-router-dom";
const Selfservice = ({ setPage, setSuccessVisible, setMessage, serUserNameProp , showLoader}) => {
    const [actionState, setActionState] = useState("password")
    const [error, setError] = useState('')
    const [phone, setPhone] = useState();
    const [username, setUsername] = useState();
    // const [verifyClass, setVerifyClass] = useState('grayout')
    const [verifyClass, setVerifyClass] = useState('grayout')
    const [otpsent, setOTPSent] = useState(false)
    const [otpValue, setOtpValue] = useState("")
    const [otpState, setOtpState] = useState("r")
    const [navig, getPage] = useState("login")
    const handleOnchange = (val) => {
        val.length >= 6 ? setVerifyClass("active") : setVerifyClass('grayout')
    }
    const [verifiedUser, setverifiedUser] = useState(false)
    const verifyOtp = (e) => {
        e.preventDefault()
        const payload = {
            "username": username,
            "otp": otpValue
        }
        ApiService.post("/auth/validate_otp", payload).subscribe(
            (res) => {
                showLoader(false)
                if ((res.data !== undefined || res.data !== null) && res.data.valid) {
                    setOtpState("s")
                    if (actionState === 'password') {
                        setverifiedUser(true)
                        serUserNameProp(username)
                    }
                } else {
                    setError("Invalid OTP")
                }
            });
    }


    const changePassword = (e) => {
        e.preventDefault();
        try {
            let payload = { "mobileNumber": phone, "type": actionState === "password" ? 2 : 1 }
            let uri = '/auth/recover_account';
            ApiService.post(uri, payload).subscribe((res) => {
                if (res.data !== undefined && res.data !== null) {
                    
                } else {
                    setError("An error occurred");
                }
            })
        } catch (e) {
            console.log("An error occurred" + e)
        } finally {

        }
        // setPage("password")
    }


    const sendOTP = (e) => {
        e.preventDefault();
        showLoader(true)
        try {
            let payload = { "mobileNumber": username, "type": actionState === "password" ? 2 : 1 }
            let uri = '/auth/recover_account';
            ApiService.post(uri, payload).subscribe((res) => {
                showLoader(false)
                if (res.status === 200) {
                    setOTPSent(true)
                    setOtpState("v")

                } else if (notEmpty(res.response) && notEmpty(res.response.data) && notEmpty(res.response.data.status)) {
                    setError(res.response.data.error)

                } else {
                    setError("An error occurred");
                }

            })
        } catch (e) {
            console.log("An error occurred" + e)
        } finally {

        }
    }
    const recoverUsername = (e) => {
        e.preventDefault();
        showLoader(true)
        try {
            let payload = { "mobileNumber": phone, "type": actionState === "password" ? 2 : 1 }
            let uri = '/auth/recover_account';
            ApiService.post(uri, payload).subscribe((res) => {
                showLoader(false)



                if (res.status === 200) {
                    setSuccessVisible(true)
                    setMessage("Your username has been sent to your registered phone number successfully")

                } else if (notEmpty(res.response) && notEmpty(res.response.data) && notEmpty(res.response.data.status)) {
                    setError(res.response.data.error)

                } else {
                    setError("An error occurred");
                }


            })
        } catch (e) {
            console.log("An error occurred" + e)
        } finally {

        }

    }

    return (
        <>

            <h1 className="login-card-sub-title" style={{ marginTop: '-1rem' }}>I have trouble  </h1>
            <h1 className="login-card-sub-title" style={{ marginTop: '-1rem', marginBottom: '2rem' }}> logging in</h1>

            <form className="form input-row self-care">
                <div className="verify_wrapper_form_container">
                    <label htmlFor="select_wallet" className="verify_wrapper_form_label">
                        Login issue
                    </label>
                    <select onChange={(e) => setActionState(e.target.value)} name="wallets" className="select-input input-clasic help-type" id="t">
                        <option value="password">Forgot password</option>
                        <option value="username">Forgot username</option>
                    </select>
                </div>

                <div className="verify_wrapper_form_container">
                    <label className="verify_wrapper_form_label">
                        {actionState === "username" ? "Mobile number" : "Username"}
                    </label>
                    {actionState === "password" && <input value={username} onChange={(e) => { handleOnchange(e.target.value); setUsername(e.target.value); setError('') }} type="text" placeholder="Enter username" className="input-text username" />}
                    {actionState === "username" && <input value={phone} onChange={(e) => { handleOnchange(e.target.value); setPhone(e.target.value); setError('') }} type="tel" placeholder="0736000000" className="" />}
                </div>
                <div className={`verify_wrapper_form_container ${actionState === "password" ? "" : 'smooth-toggle-element'}`}>
                    <label className="verify_wrapper_form_label">
                        Verification code
                    </label>
                    <div className="verify_wrapper_form_container_sub">
                        <input onChange={(e) => {
                            // Handle paste
                            var regex = /[0-9]|\./;

                            if (regex.test(e.target.value)) {
                                setOtpValue(e.target.value)
                            }


                        }} placeholder="x x x x" type="text" id="farmer_id" className="input-inline" disabled = { otpState === 'v' ? '' : 'disabled'} />
                        {otpState === "s" && <button onClick={(e) => { e.preventDefault() }} className="btn-submit inline" ><svg height={10} width={10} id="icon-checkmark" viewBox="0 0 32 32">
                            <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"></path>
                        </svg></button>}
                        {(otpState === "r" || otpState === "v") && <button className={`btn-submit inline ${verifyClass}`} onClick={(e) => { !otpsent ? sendOTP(e) : verifyOtp(e) }}>
                            {otpsent ? "Verify OTP" : "Get OTP"}
                        </button>
                        }
                    </div>

                </div>

                {error !== "" ? <>
                    <label htmlFor="farmer_id" className="error-label">
                        {error}
                    </label> </> : <></>
                }



            </form>

            <div className="verify_wrapper_form_container_btns">
                <button onClick={() => setPage("login")} className="btn-submit">
                    Back
                </button>
                {actionState === "password" && verifiedUser ? <button onClick={(e) => verifiedUser ? setPage("reset") :  setError("An error ocurred")} className="btn-submit"> Next  </button>
                    : actionState === "password" && !verifiedUser ? <button onClick={(e) => verifiedUser ? changePassword(e) :  setError("User not verified")} className="btn-submit"> Next  </button>
                        : <button onClick={(e) => actionState === "password" ? changePassword(e) : actionState === "username" ? recoverUsername(e) :  setError("User not verified")} className="btn-submit">Next</button>
                }
            </div>        </>

    );
}
export const notEmpty = (str) => {
    if (str !== undefined && JSON.stringify(str).length > 0 && str !== "") {
        return true
    }
    return false
}
export default Selfservice;
